import { Editor } from "slate";
import { Plugin } from "slate-react";

/**
 * Slate plugin to add a `isToggled_${type}` query
 */
export const AddIsToggledQuery = (type: string, action: (editor: Editor) => boolean): Plugin => ({
    queries: {
      [`isToggled_${type}`]: action,
    },
  }
);
